/**
 * #1075 — project title fields are not login credentials.
 * Password managers were filling the user's email into "Name your project".
 */

export const PROJECT_TITLE_INPUT_NAME = 'brainstormy-project-title';

export const EMAILISH_PROJECT_NAME_WARNING =
  'That looks like an email address. Use a story or series title instead?';

/**
 * Soft-detect an email-shaped title: local-part + @ + domain-ish suffix.
 * Not a validator — callers only warn, never block.
 */
export function looksLikeEmailAddress(value) {
  const trimmed = String(value || '').trim();
  if (!trimmed) return false;
  return /^[^\s@]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(trimmed);
}

/** Chrome / 1Password / LastPass / Bitwarden ignore hints. */
export const PROJECT_TITLE_AUTOFILL_ATTRS = {
  autoComplete: 'off',
  autoCorrect: 'off',
  autoCapitalize: 'none',
  name: PROJECT_TITLE_INPUT_NAME,
  'data-1p-ignore': 'true',
  'data-lpignore': 'true',
  'data-form-type': 'other',
  'data-bwignore': 'true',
};
